const content = require('../data/content.js');

let api = {
  getContent(language = 'en') {
    return content.filter(obj => obj.lang === language)[0]["page"];
  }
};

module.exports = api;


// WEBPACK FOOTER //
// ./src/components/language/language_api.js